/* A/B variant B behavior — select-then-add size pills wired to BOTH the in-page CTA
   and the sticky bar, plus the more-offers toggle. document-scoped so the sticky bar
   (which lives outside the buy-box column) is covered too. */
(function(){
  function init(){
    var selVid=null, selSize=null;
    var atcTitle=document.querySelector('#bpdp-atc .bpdp-atc-title');
    var vidInput=document.querySelector('#bpdp-variant-id');
    // Build the inline size selector ENTIRELY in JS from the (reliable) size MODAL, inserted under the
    // price. The modal renders last in the template so its size data is always complete; reading
    // product.variants / options_with_values early in Liquid intermittently returns a partial set.
    (function buildInlineSizes(){
      if(document.querySelector('[data-bpdp-absize]')) return;
      var modal=document.getElementById('bpdp-modal-sizes');
      var cells=modal?modal.querySelectorAll('.bpdp-size-cell'):[];
      if(!cells.length) return;
      var ref=document.querySelector('.bpdp-tax-note')||document.querySelector('.bpdp-price-line');
      if(!ref||!ref.parentNode) return;
      var wrap=document.createElement('div'); wrap.className='bpdp-absize'; wrap.setAttribute('data-bpdp-absize','');
      var lr=document.createElement('div'); lr.className='bpdp-absize__labelrow';
      /* Variant C: "Select size · {size}" label on the LEFT (image #16) */
      var lbl=document.createElement('span'); lbl.className='bpdp-absize__label'; lbl.innerHTML='Select size<span class="bpdp-absize__sel" data-bpdp-sel-size></span>'; lr.appendChild(lbl);
      if(document.getElementById('bpdp-modal-size-chart')||document.querySelector('.bpdp-size-chart-link')||typeof window.loadKiwiSizingChart==='function'){
        var cb=document.createElement('button'); cb.type='button'; cb.className='bpdp-absize__chart'; cb.setAttribute('data-bpdp-sizechart','');
        cb.innerHTML='<span aria-hidden="true">\uD83D\uDCCF</span> Size chart'; lr.appendChild(cb);
      }
      wrap.appendChild(lr);
      var grid=document.createElement('div'); grid.className='bpdp-absize__grid'; grid.setAttribute('data-bpdp-absize-grid','');
      var anyAvail=false, anyOOS=false;
      Array.prototype.forEach.call(cells,function(cell){
        var avail=cell.hasAttribute('data-bpdp-pick-size');
        var size=cell.getAttribute('data-size')||cell.getAttribute('data-bpdp-notify-size'); if(!size) return;
        var pill=document.createElement('button'); pill.type='button'; pill.setAttribute('data-size',size); pill.textContent=size;
        if(avail){ var vid=cell.getAttribute('data-variant-id'); pill.className='bpdp-size-pill'; pill.setAttribute('data-bpdp-ab-size',''); if(vid) pill.setAttribute('data-variant-id',vid); ['data-price','data-compare','data-price-money','data-compare-money'].forEach(function(a){var val=cell.getAttribute(a); if(val!=null) pill.setAttribute(a,val);}); anyAvail=true; }
        else { pill.className='bpdp-size-pill is-unavailable'; pill.setAttribute('data-bpdp-ab-oos',''); anyOOS=true; pill.innerHTML='<span class="bpdp-pill-size">'+size+'</span><span class="bpdp-pill-notify">Notify</span>'; pill.addEventListener('click',function(){ cell.click(); }); /* OOS pill: bold diagonal-struck size + tiny Notify label; tap opens Notify-Me via the source modal cell (carries SKU + respects BPDP_NOTIFY_LIVE) */ }
        grid.appendChild(pill);
      });
      wrap.appendChild(grid);
      /* 2026-06-25: removed the "In stock \u00b7 ships in 2 days" line AND the sold-out "Tap to get notified" hint (per request). OOS size pills keep their own tappable "Notify" affordance. */
      ref.parentNode.insertBefore(wrap, ref.nextSibling);
      /* 2026-06-25: move the COD / Free shipping / 30-day returns trust row to sit ABOVE the size-chart / size selector */
      (function(){ var tr=document.querySelector('.bpdp-trust-row'); if(tr && wrap.parentNode){ wrap.parentNode.insertBefore(tr, wrap); } })();
    })();
    var sizeWrap=document.querySelector('.bpdp-absize');
    function reflect(){
      if(atcTitle) atcTitle.textContent = selSize ? ('ADD TO CART \u00b7 '+selSize) : 'ADD TO CART';
      Array.prototype.forEach.call(document.querySelectorAll('#bpdp-sticky .bpdp-sticky-half-sub'),function(s){
        s.textContent = selSize ? ('Size '+selSize) : '';
      });
      var selEl=document.querySelector('[data-bpdp-sel-size]'); if(selEl) selEl.textContent = selSize ? (' · '+selSize) : '';
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-bpdp-ab-size]'),function(p){
      p.addEventListener('click',function(){
        Array.prototype.forEach.call(document.querySelectorAll('[data-bpdp-ab-size]'),function(x){x.classList.remove('is-selected');});
        p.classList.add('is-selected');
        selVid=p.getAttribute('data-variant-id'); selSize=p.getAttribute('data-size');
        if(vidInput) vidInput.value=selVid;
        /* Update the displayed price to the selected variant's price (variants can have
           different MRPs by size, e.g. XXL). Money strings come straight from Liquid `| money`
           so the format matches the server-rendered price exactly. — 2026-06-17 */
        (function(){
          var ip=parseInt(p.getAttribute('data-price')||'0',10), ic=parseInt(p.getAttribute('data-compare')||'0',10);
          var mp=p.getAttribute('data-price-money'), mc=p.getAttribute('data-compare-money');
          if(!mp) return;
          var elCur=document.getElementById('bpdp-price-cur'), elWas=document.getElementById('bpdp-price-was'), elSave=document.getElementById('bpdp-price-save');
          if(elCur) elCur.textContent=mp;
          var disc = ic>ip && ip>0;
          if(elWas){ if(disc&&mc){ elWas.textContent=mc; elWas.style.display=''; } else { elWas.style.display='none'; } }
          if(elSave){ if(disc){ elSave.textContent=Math.floor((ic-ip)*100/ic)+'% OFF'; elSave.style.display=''; } else { elSave.style.display='none'; } }
          /* keep analytics price (add_to_cart value) in sync with the selected variant */
          var pr=document.querySelector('[data-product-id]'); if(pr) pr.setAttribute('data-product-price',mp);
        })();
        reflect();
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-bpdp-ab-add]'),function(b){
      b.addEventListener('click',function(){
        var intent=b.getAttribute('data-bpdp-intent')||'add';
        if(!selVid){
          /* No size chosen: SCROLL the buyer up to the size pills and flash them, so a click always
             has an obvious result (the theme blocks programmatic size-modal open, so we guide to the pills). */
          if(sizeWrap){ sizeWrap.scrollIntoView({behavior:'smooth',block:'center'}); sizeWrap.classList.add('bpdp-absize--flash'); setTimeout(function(){sizeWrap.classList.remove('bpdp-absize--flash');},900); }
          return;
        }
        b.setAttribute('data-bpdp-active','1');
        if(typeof bpdpAddToCart==='function') bpdpAddToCart(selVid,intent);
      });
    });
    /* 2026-09-07: FIND IN STORE — jump to the #bb-sa store block, auto-switch to the "In store"
       tab (its approximate availability auto-loads there, so it shows available-or-not with no
       extra tap). On store_code (ad) PDPs there's no tab — the availability card is already shown,
       so we just scroll to it. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-bpdp-find-store]'),function(b){
      b.addEventListener('click',function(){
        var wrap=document.getElementById('bb-sa');
        if(!wrap){ return; }
        function bringIntoView(){
          /* Bring the "SEARCH STORES NEAR ME" button to the CENTRE of the viewport (above the mobile
             sticky CTA bar). Centring the whole #bb-sa block would push the button below the fold —
             the block is taller than a phone screen. Fallbacks: the In-store pane, then the block. */
          var t=wrap.querySelector('.bb-t-pane[data-p="ins"] .bb-t-search')
              || wrap.querySelector('.bb-t-pane[data-p="ins"]') || wrap;
          try{ t.scrollIntoView({behavior:'smooth',block:'center'}); }catch(e){ try{ t.scrollIntoView(); }catch(_){} }
        }
        var tries=0;
        (function go(){
          var insTab=wrap.querySelector('.bb-t-tab[data-t="ins"]');
          if(insTab){
            if(!insTab.classList.contains('is-on')) insTab.click();
            setTimeout(bringIntoView,60);   // after the In-store pane unhides + lays out
            return;
          }
          if(++tries<20){ setTimeout(go,120); return; }
          bringIntoView();   // no In-store tab (store_code/LIA card path) — just scroll the card in
        })();
      });
    });
    var moreBtn=document.querySelector('[data-bpdp-ab-more]'), moreWrap=document.getElementById('bpdp-ab-offers-more');
    if(moreBtn&&moreWrap){ moreBtn.addEventListener('click',function(){ var o=moreWrap.classList.toggle('is-open'); moreBtn.innerHTML=o?'less offers \u25b4':'more offers \u25be'; }); }
    var chartBtn=document.querySelector('[data-bpdp-sizechart]');
    if(chartBtn){ chartBtn.addEventListener('click',function(e){ e.preventDefault();
      /* Kiwi has no openModal API; it injects a (hidden) trigger near the dead size-modal's
         .bpdp-size-chart-link — clicking THAT opens the Kiwi chart. Fallback: native image modal. */
      var k=document.querySelector('.ks-chart-modal-link,.sizing-chart-modal-link,.kiwi-sizing-link,.kiwi-sizing-button');
      if(k){ k.click(); return; }
      if(typeof window.loadKiwiSizingChart==='function'){ try{ window.loadKiwiSizingChart(); var k2=document.querySelector('.ks-chart-modal-link,.sizing-chart-modal-link'); if(k2){ k2.click(); return; } }catch(_){} }
      var m=document.getElementById('bpdp-modal-size-chart'); if(m) m.classList.add('is-open');
    }); }
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
